import React from 'react'
import { Header, Form, Input, Message, Icon } from 'semantic-ui-react'
import EmploymentHistory, { DEFAULT_EMPLOYMENT } from './EmploymentHistory'
import PublicLinks from './PublicLinks'
import Credentials from './Credentials'
import ProfessionalRegistration from './ProfessionalRegistration'

export const DEFAULT_PROFESSIONAL_INFO = {
  employmentHistory: [DEFAULT_EMPLOYMENT],
  publicLinks: [],
  credentials: [],
  hourlyRate: 0,
}

const Professional = ({
  profile,
  setProfile,
  skipHeader,
  skipHourlyRate,
  showProfessionalRegistration = false,
}) => (
  <div id="professional-section">
    {!skipHeader && <Header as="h4">Professional Information</Header>}
    <div className="content">
      <Form>
        <EmploymentHistory
          employmentHistory={profile.employmentHistory}
          setEmploymentHistory={(employmentHistory) =>
            setProfile({ ...profile, employmentHistory })
          }
        />
        <br />
        <PublicLinks
          publicLinks={profile.publicLinks}
          setPublicLinks={(publicLinks) =>
            setProfile({ ...profile, publicLinks })
          }
        />
        <br />
        {showProfessionalRegistration && (
          <>
            <ProfessionalRegistration
              country={profile.country}
              professionalRegistrations={profile.professionalRegistrations}
              setProfessionalRegistrations={(professionalRegistrations) =>
                setProfile((current) => ({
                  ...current,
                  professionalRegistrations,
                }))
              }
              noRegistration={!!profile.noProfessionalRegistration}
              setNoRegistration={(noProfessionalRegistration) =>
                setProfile((current) => ({
                  ...current,
                  noProfessionalRegistration,
                }))
              }
            />
            <br />
          </>
        )}
        <Credentials
          credentials={profile.credentials}
          setCredentials={(credentials) =>
            setProfile({ ...profile, credentials })
          }
        />
        {!skipHourlyRate && (
          <>
            <Form.Field required>
              <label>Hourly rate for consultation</label>
              <div className="ui right labeled input">
                <label htmlFor="hourly_rate_field" className="ui label">
                  $
                </label>
                <Input
                  type="number"
                  placeholder="300"
                  onChange={(e, { value }) =>
                    setProfile({
                      ...profile,
                      hourlyRate: value ? parseInt(value) : 0,
                    })
                  }
                  value={profile.hourlyRate}
                  min="1"
                  style={{
                    display: 'inline',
                    width: '20%',
                  }}
                  id="hourly_rate_field"
                />
                <div className="ui basic label">USD</div>
              </div>
            </Form.Field>
            <Message icon id="iv-hourly-rate-message">
              <Icon name="info circle" id="iv-hourly-rate-message-icon" />
              <Message.Content>
                <p>
                  A typical Dexter expert earns $200 - $300 per hour for their
                  insights.
                </p>
              </Message.Content>
            </Message>
          </>
        )}
      </Form>
    </div>
  </div>
)

export default Professional
